import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const PremiumAccess = ({ onSubscribe }) => {
  const benefits = [
    "Exclusive high-conviction setups",
    "Members-only strategy drops",
    "Premium live trading sessions",
    "Advanced market intelligence"
  ];

  return (
    <div className="w-full py-20 bg-[#0a0a0a] relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-12">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative w-full max-w-5xl mx-auto rounded-3xl overflow-hidden glass border border-white/10 bg-gradient-to-br from-[#151515] to-[#0a0a0a] p-8 md:p-12 shadow-2xl"
        >
          {/* Subtle Background Glow */}
          <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-rocket/10 blur-[100px] rounded-full pointer-events-none translate-x-1/3 -translate-y-1/3" />
          
          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-10">
            <div className="flex-1">
              <div className="inline-flex items-center space-x-2 bg-rocket/10 border border-rocket/20 px-3 py-1.5 rounded-full mb-6">
                <SafeIcon name="Star" className="w-4 h-4 text-rocket" />
                <span className="text-xs font-bold text-rocket uppercase tracking-wider">Premium Access</span>
              </div>
              
              <h2 className="text-3xl md:text-4xl font-black text-white mb-4 tracking-tight">
                Unlock the Full <br className="hidden md:block"/> RocketAlgo Experience.
              </h2>
              <p className="text-gray-400 text-lg mb-8 max-w-md">
                Elevate your trading with institutional-grade intelligence and exclusive streaming content.
              </p>
              
              <ul className="space-y-3 mb-8">
                {benefits.map((benefit, i) => (
                  <li key={i} className="flex items-center text-gray-300 text-sm font-medium">
                    <span className="w-1.5 h-1.5 rounded-full bg-rocket mr-3 shadow-[0_0_5px_rgba(255,102,0,0.8)]" />
                    {benefit}
                  </li>
                ))}
              </ul>
            </div>

            <div className="w-full md:w-auto flex flex-col sm:flex-row md:flex-col gap-4">
              <button 
                onClick={onSubscribe}
                className="w-full sm:w-auto md:w-full bg-rocket hover:bg-rocket-hover text-white px-8 py-4 rounded-xl font-bold text-lg transition-all shadow-[0_0_20px_rgba(255,102,0,0.3)] hover:shadow-[0_0_30px_rgba(255,102,0,0.5)] transform hover:-translate-y-1 flex items-center justify-center group"
              >
                Explore Membership
                <SafeIcon name="ArrowRight" className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform" />
              </button>
              <button 
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="w-full sm:w-auto md:w-full glass hover:bg-white/10 text-white px-8 py-4 rounded-xl font-bold transition-all flex items-center justify-center"
              >
                Watch Preview
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PremiumAccess;